
import { API } from "aws-amplify";
import { Auth } from "aws-amplify";

const API_NAME = "virtualofficeapi"

export interface AvatarType {
    head: string
    body: string
    shirt: string
    jacket: string
    hair: string
    eye:  string
    nose: string
    mouth: string
    accessory: string
    background: string
    bodyColor: string
    hairColor: string
    eyeColor: string
    backgroundColor: string
}

export interface JoinMemberType {
    id: string
    name: string
    email: string
    avatar: AvatarType
    icon: {
        get: string
    }
    status: string
    busyness: number
    comment: string
    lastAccess: string
    join: true
    attributes: {
        [key:string]: string
    }
}
export interface UnJoinMemberType {
    id: string
    email: string
    join: false
}
export type MemberType = (JoinMemberType|UnJoinMemberType)
export type MemberListType = MemberType[]

export interface RoomTextFieldType {
    id: string
    type: "text"
    label: string
    placeholder?: string | undefined
}
export interface RoomSelectFieldType {
    id: string
    type: "select"
    label: string
    placeholder?: string | undefined
    options: {id: string, value: string}[]
}
export type RoomFieldType = RoomTextFieldType | RoomSelectFieldType
export type RoomFieldListType = RoomFieldType[]

export interface RoomType {
    id: string
    name: string
    description: string
    theme: string
    owner: string
    lastAccess?: (string | undefined)
    fields?: (RoomFieldListType | undefined)
    members?: (MemberListType | undefined)
    lastModified: string 
    memberId?: string
    join: boolean
}
export type RoomListType = RoomType[]

export interface GetMyInfoRequestType {
}
export interface GetMyInfoResponseType {
    name: string
    email: string
    icon: {
        get?: string | undefined
        set?: string | undefined
    }
    avatar: AvatarType
    status: string
    busyness: number
    comment: string
}
export const getMyInfo = async (input: GetMyInfoRequestType): Promise<GetMyInfoResponseType> => {
    const response = await API.get(API_NAME, "/api/myinfo", {
        headers: {
            "Authorization": `Bearer ${((await Auth.currentSession()).getIdToken().getJwtToken())}`,
        }
    }) as GetMyInfoResponseType

    return response
}

export interface SetMyInfoRequestType {
    name: string
    avatar: AvatarType
    status: string
    busyness: number
    comment: string
}
export interface SetMyInfoResponseType {
    name: string
    email: string
    icon: {
        get?: string | undefined
        set?: string | undefined
    }
    avatar: AvatarType
    status: string
    busyness: number
    comment: string
}
export const setMyInfo = async (input: SetMyInfoRequestType): Promise<SetMyInfoResponseType> => {
    const response = await API.put(API_NAME, "/api/myinfo", {
        headers: {
            "Authorization": `Bearer ${((await Auth.currentSession()).getIdToken().getJwtToken())}`,
        },
        body: {
            name: input.name,
            avatar: input.avatar,
            status: input.status,
            busyness: input.busyness,
            comment: input.comment,
        }
    }) as SetMyInfoResponseType

    return response 
}

export interface JoinRoomRequest {
    roomId: string
    memberId: string
}
export interface JoinRoomResponse {

}
export const joinRoom = async (input: JoinRoomRequest): Promise<JoinRoomResponse> => {
    const response = await API.put(API_NAME, `/api/rooms/${input.roomId}/members/${input.memberId}?join=true`, {
        headers: {
            "Authorization": `Bearer ${((await Auth.currentSession()).getIdToken().getJwtToken())}`,
        }
    }) as JoinRoomResponse
    return response
}

export interface GetRoomsRequestType {
    next?: string | undefined
}
export interface GetRoomsResponseType {
    rooms: RoomListType
    next: string | undefined
}
export const getRooms = async (input:GetRoomsRequestType): Promise<GetRoomsResponseType> => {
    const response = await API.get(API_NAME, `/api/rooms?${input.next ? `next=${encodeURIComponent(input.next)}` : ""}`, {
        headers: {
            "Authorization": `Bearer ${((await Auth.currentSession()).getIdToken().getJwtToken())}`,
        }
    }) as GetRoomsResponseType
    return response
}

export interface CreateRoomRequestType {
    name: string
    description: string
    theme: string
}
export const createRoom = async (input:CreateRoomRequestType): Promise<RoomType> => {
    const response = await API.post(API_NAME, "/api/rooms", {
        headers: {
            "Authorization": `Bearer ${((await Auth.currentSession()).getIdToken().getJwtToken())}`,
        },
        body: {
            name: input.name,
            description: input.description,
            theme: input.theme,
        }
    }) as RoomType
    return response 
}

export interface GetRoomRequestType {
    id: string
}
export const getRoom = async (input:GetRoomRequestType): Promise<RoomType> => {
    const response = await API.get(API_NAME, `/api/rooms/${input.id}`, {
        headers: {
            "Authorization": `Bearer ${((await Auth.currentSession()).getIdToken().getJwtToken())}`,
        }
    }) as RoomType
    return response 
}

export interface GetRoomMemberRequestType {
    roomId: string
    memberId: string
}
export interface GetRoomMemberResponseType {

}
export const getRoomMember = async (input:GetRoomMemberRequestType): Promise<GetRoomMemberResponseType> => {
    const response = await API.get(API_NAME, `/api/rooms/${input.roomId}/members/${input.memberId}`, {
        headers: {
            "Authorization": `Bearer ${((await Auth.currentSession()).getIdToken().getJwtToken())}`,
        },
    })

    return response
}

export interface GetRoomMembersRequestType {
    roomId: string
    memberIds?:  (string|undefined)[]
}
export const getRoomMembers = async (input:GetRoomMembersRequestType): Promise<MemberListType> => {
    const query = input.memberIds?.filter((r,i,self)=>r && self.indexOf(r) === i).map(id=>`memberId%5B%5D=${encodeURIComponent(id || "")}`).join("&") || ""
    const response = await API.get(API_NAME, `/api/rooms/${input.roomId}/members?${query}`, {
        headers: {
            "Authorization": `Bearer ${((await Auth.currentSession()).getIdToken().getJwtToken())}`,
        },
    })

    return response
}


export interface PutRoomMembersRequestType {
    roomId: string
    members: {
        email: string
    }[]
}
export const putRoomMembers = async (input:PutRoomMembersRequestType): Promise<MemberListType> => {
    const response = await API.put(API_NAME, `/api/rooms/${input.roomId}/members`, {
        headers: {
            "Authorization": `Bearer ${((await Auth.currentSession()).getIdToken().getJwtToken())}`,
        },
        body: input.members
    })

    return response
}

export interface QueryNotificationRequestType {
    resource: string
    id: string
    lastModified: string
}
export interface QueryNotificationsResponseType {
    notifications: QueryNotificationsNotificationsType[]
    lastModified: string
}
export interface QueryNotificationsNotificationsType {
    id: string
    timestamp: string 
    code: string
    resourceId: string
    attributes?: any
}
export const queryNotifications = async (input: QueryNotificationRequestType): Promise<QueryNotificationsResponseType> => {
    const response = await API.get(API_NAME, `/api/notifications/${input.resource}/${input.id}?${input.lastModified ? `lastModified=${encodeURIComponent(input.lastModified)}` : ""}`, {
        headers: {
            "Authorization": `Bearer ${((await Auth.currentSession()).getIdToken().getJwtToken())}`,
        }, 
    })

    return response
}